const Reminder3Notification = `[TESTE] Olá _*{{CONTACT.NAME}}*_ espero que você e seu bebê estejam bem! 😊

Se tiver alguma dificuldade com nosso questionário pode me falar que consigo te auxiliar.

Ah, e o link está aqui: {{LINK.FORMS}}

Se puder tirar 2 minutinhos para responder é muito importante, e te agradeço 🙏🏻🤗

_*{{USER.NAME}}*_ e _*Equipe Projeto PEARLS Brazil*_ _UNIFESP_`;

export { Reminder3Notification };
